export default "/images/settings-active-light.svg?ea9481f27ae0b4f356c2bc4274bd6e8b";